<template>
    <gofix-card title=" " classHeader="p-0 m-0" class="heig-frame-child" fullContent :class="{'run-loading': loading}">
        <gofix-table
            class="noFullHeight scrollAbsolute"
            :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @new-item="openModal"
            @row-click="openModal"
            @delete-items="deleteItems"
            ref="gofixTable">
            <template slot="gofix_table:showable" slot-scope="row">
                <b-form-checkbox v-model="row.item.showable" :value="true" @change="updteShowable(row.item)"></b-form-checkbox>
            </template>
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
            <b-form class="pb-20">
                <gofix-form-input label="Action" v-model="modal.data.reference_value_text" required></gofix-form-input>
                <gofix-form-dropdown
                    label="Action Reference Key"
                    :clearable="true"
                    :show-icon-required="true"
                    vLabel="reference_value_text"
                    v-model="modal.data.reference_value_abbr"
                    :options="modal.actionReferenceKeys">
                </gofix-form-dropdown>
                <div class="custom-checkbox-modal">
                    <b-form-checkbox class="label-pl-short" v-model="modal.data.showable" :value="true">Showable</b-form-checkbox>
                </div>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    export default {
        name: 'case-hb-settings-activity',
        components: {
        },
        data () {
            return {
                tableConfig:{
                    name: 'case-settings-activity',
                    controls:{
                        createTooptip:"New Action",
                    },
                    filter: {
                       reference_value_text: {  type: "text", value: "", function: "ilike", with: [] },
                       reference_value_abbr: {  type: "text", value: "", function: "ilike", with: [] },
                       reference_type:       {  type: 'text', value: "Case Hot Button Activity", function:"=", with: [] },
                       contract_id:          {  type: "number", value: this.$route.params.id, function: "=", with: [] },
                    },
                    page: 1,
                    total: 0,
                    //isCMS: false,
                    useDatabaseView: false,
                    sortColumn: "reference_value_text",
                    sortDirection: "asc",
                    itemSelected: [],
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'reference_value_text',
                            label: 'Action',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:200px",
                            sorting: true,
                        },
                        {
                            key: 'reference_value_abbr',
                            label: 'Action Reference Key',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:300px",
                            sorting: true,
                        },
                        {
                            key: 'showable',
                            label: 'Showable',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: false,
                            with:null,
                            thStyle: "width:150px",
                            thClass: "text-center",
                            sorting: false,
                        },
                        {
                            key: 'null',
                            label: '',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: false,
                            with:null,
                            thStyle: "width:nullpx",
                            sorting: false,
                        },
                    ]
                },
                tableItems:[],
                modal:{
                    open: false,
                    loading: false,
                    title:"New Action",
                    actionType: [],
                    actionReferenceKeys: ["hot-button-manual-entry"],
                    data:{
                        id: null,
                        reference_type: "Case Hot Button Activity",
                        reference_value_text: null,
                        reference_value_abbr: null,
                        contract_id: this.$route.params.id,
                        showable: true
                    },
                },
                loading: false
            }
        },
        created() {
            this.getCaseActivityOptions();
        },
        methods:{
            //Load data list
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contract_id.value = this.$route.params.id;
                await this.$store.dispatch("ReferenceController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load the data", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },
            //Open modal Edit || Create data
            openModal(item){
                if(item){
                    this.modal.title = "Edit Action";
                    this.modal.data = {
                        id: item.id,
                        reference_type: item.reference_type,
                        reference_value_text: item.reference_value_text,
                        reference_value_abbr: item.reference_value_abbr,
                        contract_id: this.$route.params.id,
                        showable: item.showable
                    }
                }else{
                    this.modal.title = "New Action";
                    this.modal.data = {
                        id: null,
                        reference_type: "Case Hot Button Activity",
                        reference_value_text: null,
                        reference_value_abbr: null,
                        contract_id: this.$route.params.id,
                        showable: true
                    }
                }
                this.modal.open = true;
            },
            //Update & Create data
            save(){
                if(!this.modal.data.reference_value_text){
                    return this.$bvToast.toast('Action is a required field.', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                let method    = 'createItem';
                let msg    = 'added';
                if(this.modal.data.id) {
                    method = 'updateItem';
                    msg    = 'updated';
                }
                this.$store.dispatch(`ReferenceController/${method}`, this.modal.data)
                    .then(result => {
                        this.$bvToast.toast( `Successfully ${msg} action`, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'success',
                            solid: true
                        });
                        this.modal.open = false;
                        this.$refs['gofixTable'].reloadTableKeepFilter();
                    })
                    .catch(error => {
                        if(error.response && error.response.data.error.message.error) {
                            return this.$bvToast.toast(error.response.data.error.message.error, {
                                title: `Notification`,
                                autoHideDelay: 3000,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    })
            },
            //Delete data
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("ReferenceController/deleteItem", ids)
                    .then(response => {
                        resolve("Successfully deleted action");
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            getCaseActivityOptions(){
                let filter = {reference_type: "Case Hot Button Activity"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.modal.actionType = response.items;
                    })
            },
            updteShowable(item) {
                this.loading = true
                this.$store.dispatch(`ReferenceController/updateItem`, item)
                    .then(result => {
                        this.$bvToast.toast( `Successfully ${updated} action`, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'success',
                            solid: true
                        });
                        this.loading = false
                        this.$refs['gofixTable'].reloadTableKeepFilter();
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response && error.response.data.error.message.error) {
                            return this.$bvToast.toast(error.response.data.error.message.error, {
                                title: `Notification`,
                                autoHideDelay: 3000,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    })
            }
        }
    }
</script>
